// Cliente da API do sistema de suporte (chamados, técnicos, clientes, protocolo).
// Usa o mesmo login do Whaticket: envia o token de acesso dele; se expirar,
// renova pelo próprio Whaticket e repete a chamada.
import axios from "axios";
import api from "../services/api";
import { getConfig } from "../config";

const suporteApi = axios.create({
  baseURL: (getConfig("VITE_SUPORTE_API_URL") || "").replace(/\/$/, ""),
});

const tokenAtual = () => {
  try {
    return JSON.parse(localStorage.getItem("token") || "null");
  } catch {
    return null;
  }
};

suporteApi.interceptors.request.use((config) => {
  const token = tokenAtual();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// diferença entre o relógio do servidor e o do computador (PC com hora errada não atrapalha os horários)
let difServidor = 0;
export const agoraServidor = () => new Date(Date.now() + difServidor);

suporteApi.interceptors.response.use(
  (r) => {
    const d = Date.parse(r.headers?.date || "");
    if (!Number.isNaN(d)) difServidor = d - Date.now();
    return r;
  },
  async (error) => {
    const original = error.config;
    if (error?.response?.status === 401 && !original._repetida) {
      original._repetida = true;
      const { data } = await api.post("/auth/refresh_token");
      if (data?.token) {
        localStorage.setItem("token", JSON.stringify(data.token));
        api.defaults.headers.Authorization = `Bearer ${data.token}`;
      }
      return suporteApi(original);
    }
    return Promise.reject(error);
  }
);

export const mensagemErro = (err) => {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.[x.loc.length - 1]}: ${x.msg}`).join("; ");
  return d || err?.message || "Erro ao falar com o sistema de suporte";
};

// Baixa um arquivo (Excel) da API com o token, sem abrir nova aba
export const baixar = async (url, params) => {
  const r = await suporteApi.get(url, { params, responseType: "blob" });
  const nome =
    /filename="?([^"]+)"?/.exec(r.headers["content-disposition"] || "")?.[1] || "arquivo.xlsx";
  const link = document.createElement("a");
  link.href = URL.createObjectURL(r.data);
  link.download = nome;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(link.href);
};

export const urlQr = (protocolo) =>
  `${suporteApi.defaults.baseURL}/api/qr/${encodeURIComponent(protocolo)}.png`;

// endereço público do suporte (páginas sem login: consulta, link do protocolo)
export const urlPublica = (getConfig("VITE_SUPORTE_PUBLICO_URL") || suporteApi.defaults.baseURL).replace(/\/$/, "");

export const urlConsultaPublica = (protocolo) => `${urlPublica}/p/${encodeURIComponent(protocolo)}`;

export default suporteApi;
